document.addEventListener('DOMContentLoaded', function () {
  const selectors = [
    '.hero__media img',
    '.hero__media-wrapper',
    '.media-block',
    '.resource-list__item',
    '.section-background',
  ].join(', ');

  document.querySelectorAll(selectors).forEach(el => el.classList.add('scroll-fade'));

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  document.querySelectorAll('.scroll-fade').forEach(el => observer.observe(el));
});
